import { render, staticRenderFns } from "./alphanew.vue?vue&type=template&id=4fd8dc15&"
import script from "./alphanew.vue?vue&type=script&lang=js&"
export * from "./alphanew.vue?vue&type=script&lang=js&"
import style0 from "./alphanew.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports